import React from "react";
import PropTypes from "prop-types";

import IconClose from "./icons/IconClose";
import IconCheck from "./icons/IconCheck";
import IconSlack from "./icons/IconSlack";
import IconPlane from "./icons/IconPlane";
import IconChevron from "./icons/IconChevron";
import IconEdit from "./icons/IconEdit";

class Icon extends React.Component {
    getInlineContent = (props, fill) => {
        switch (props.icon) {
            case "check":
                return <IconCheck />;
            case "chevron":
                return <IconChevron />;
            case "close":
                return <IconClose />;
            case "edit":
                return <IconEdit />;
            case "plane":
                return <IconPlane />;
            case "slack":
                return <IconSlack />;
            default:
                return null;
        }
    };

    render() {
        const inlineSvg = this.getInlineContent(this.props);

        if (!this.props.icon) {
            return null;
        }

        return <span className="icon">{inlineSvg}</span>;
    }
}

Icon.propTypes = {
    icon: PropTypes.string
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.jsx